import type { Node } from "prosemirror-model";

export interface TopLevelBlock {
	index: number;
	from: number;
	to: number;
	node: Node;
}

const topLevelBlocks = (doc: Node): TopLevelBlock[] => {
	const blocks: TopLevelBlock[] = [];
	doc.forEach((node, offset, index) => blocks.push({ index, from: offset, to: offset + node.nodeSize, node }));
	return blocks;
};

// A boundary pos belongs to the next block: deleted-text insertion points sit there and belong after the seam.
export const blockIndexAt = (blocks: TopLevelBlock[], pos: number): number => {
	const found = blocks.find((block) => pos < block.to);
	return found ? found.index : Math.max(blocks.length - 1, 0);
};

export default topLevelBlocks;
